import { ServerEnv } from 'Configs/ServerEnv'
import storeCountry from 'GlobalStores/Cores/County/StoreCountry'
import storeAuth from 'GlobalStores/User/StoreAuth'
import { proxiedGet, proxiedDelete, proxiedPost } from 'Services/apiClient'

const getSavedCreditCards = async ({ userCountry }) => {
    const response = await proxiedGet(`${ServerEnv.HydraV6()}/customers/me/creditcardaliases/${userCountry}`, {
        config: {
            headers: {
                Authorization: `Bearer ${storeAuth.GetToken()}`,
                'Content-Type': 'application/json',
                'x-application': `asia.fg.${storeCountry.Country2().toLowerCase()}`
            }
        }
    })
    return response
}

const deleteSavedCreditCard = async ({ cardAlias, userCountry }) => {
    const response = await proxiedDelete(`${ServerEnv.HydraV6()}/customers/me/creditcardaliases/${userCountry}/${cardAlias}`, {
        config: {
            headers: {
                Authorization: `Bearer ${storeAuth.GetToken()}`,
                'Content-Type': 'application/json',
                'x-application': `asia.fg.${storeCountry.Country2().toLowerCase()}`
            }
        }
    })

    return response
}

const saveCreditCard = async ({ methodDetails, userCountry }) => {
    const response = await proxiedPost(`${ServerEnv.HydraV6()}/customers/me/creditcardaliases/${userCountry}`, methodDetails, {
        config: {
            headers: {
                Authorization: `Bearer ${storeAuth.GetToken()}`,
                'Content-Type': 'application/json',
                'x-application': `asia.fg.${storeCountry.Country2().toLowerCase()}`
            }
        }
    })

    return response
}

const getRemainingTime = async () => {
    const response = await proxiedGet(`https://${ServerEnv.MemberCalls2()}.unicity.com/hot/remoteStorage/data/creditcard-alias`)
    return response.data
}

export const savedCreditCardApis = {
    getSavedCreditCards,
    deleteSavedCreditCard,
    saveCreditCard,
    getRemainingTime
}
